import clsx from "clsx";
import { Icon } from "../../../../components";

const RlNavigationIcon = ({
  name,
  className
}: {
  name: string;
  className?: string;
}) => <Icon name={name} className={clsx("main-nav__item-icon", className)} />;

export default RlNavigationIcon;
